import { Link } from "react-router-dom";
import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";
import BackToTop from "@/components/feature/BackToTop";

const principles = [
  {
    icon: "ri-focus-3-line",
    title: "内容够纯粹",
    desc: "桃桃漫画网只收录情感发展细腻、心动瞬间密集的恋爱作品，宁缺毋滥，拒绝注水与烂尾。",
  },
  {
    icon: "ri-heart-3-fill",
    title: "选品够走心",
    desc: "每一部作品都经过编辑试读与把关，重点看剧情张力、人物化学反应与脸红桥段的浓度。",
  },
  {
    icon: "ri-flashlight-fill",
    title: "推荐够对味",
    desc: "六大剧情栏目精准切分不同恋爱口味，配合心动指数与编辑精选，帮你少走弯路直接找到对味作品。",
  },
  {
    icon: "ri-community-fill",
    title: "体验够贴心",
    desc: "更新实时上架、订阅及时提醒，追更体验顺畅，让每一次心动都不被错过。",
  },
];

const testimonials = [
  {
    name: "小桃A",
    role: "纯爱甜宠党",
    text: "在这里找到了超对味的甜宠漫，感情线慢慢升温的那种最戳我，脸红桥段真的会跟着心跳加速！",
    avatar:
      "https://readdy.ai/api/search-image?query=Cute%20chibi%20anime%20girl%20avatar%20with%20warm%20peach%20hair%2C%20soft%20smile%2C%20simple%20clean%20illustration%20style&width=200&height=200&seq=avatar-f-01&orientation=squarish",
  },
  {
    name: "桃子不酸",
    role: "冤家拉扯爱好者",
    text: "喜欢相爱相杀的拉扯感，桃桃的栏目分得很细，一进冤家区就是高能连击，太上头了。",
    avatar:
      "https://readdy.ai/api/search-image?query=Cute%20chibi%20anime%20boy%20avatar%20with%20messy%20coral%20hair%20and%20a%20cheeky%20grin%2C%20simple%20clean%20illustration%20style&width=200&height=200&seq=avatar-m-01&orientation=squarish",
  },
  {
    name: "脸红星人",
    role: "编辑精选粉",
    text: "编辑部的眼光很稳，推的每一部都踩在我的心动点上，剧情解读也写得超用心，爱了。",
    avatar:
      "https://readdy.ai/api/search-image?query=Cute%20chibi%20anime%20girl%20avatar%20with%20short%20pink%20hair%20and%20blushing%20cheeks%2C%20simple%20clean%20illustration%20style&width=200&height=200&seq=avatar-f-02&orientation=squarish",
  },
];

const schema = {
  "@context": "https://schema.org",
  "@type": "AboutPage",
  name: "关于桃桃漫画网",
  description:
    "桃桃漫画网是一个专注桃色剧情、暧昧桥段、脸红情节与恋爱拉扯类漫画的在线阅读平台，为喜欢慢热感情线的读者精选情感发展细腻、心动瞬间密集的恋爱作品。",
  url: "https://emovibe1.github.io/about",
  inLanguage: "zh-CN",
};

const orgSchema = {
  "@context": "https://schema.org",
  "@type": "Organization",
  name: "桃桃漫画网",
  url: "https://emovibe1.github.io/",
  description: "桃色剧情恋爱拉扯在线看，精选暧昧桥段与心动瞬间高能合集的恋爱漫画平台。",
  contactPoint: {
    "@type": "ContactPoint",
    email: "hello@taotao-manga.example.com",
    contactType: "customer service",
  },
};

export default function AboutPage() {
  return (
    <>
      <Navbar />
      <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(schema) }} />
      <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(orgSchema) }} />
      <main className="pt-16 md:pt-[72px]">
        {/* 面包屑 */}
        <div className="mx-auto w-full max-w-[1400px] px-4">
          <nav aria-label="面包屑" className="flex items-center gap-1.5 py-5 text-sm text-foreground-500">
            <Link to="/" className="transition-colors hover:text-primary-600">首页</Link>
            <i className="ri-arrow-right-s-line"></i>
            <span className="text-foreground-800">关于我们</span>
          </nav>
        </div>

        {/* 关于页首屏 */}
        <section className="bg-gradient-to-br from-primary-50 via-background-100 to-background-50">
          <div className="mx-auto flex w-full max-w-[1400px] flex-col items-center px-4 py-14 text-center md:py-20">
            <span className="flex items-center gap-2 rounded-full bg-background-50 px-4 py-1.5 text-sm font-medium text-primary-600">
              <i className="ri-heart-3-fill"></i>
              关于桃桃漫画网
            </span>
            <h1 className="mt-5 max-w-3xl font-display text-4xl leading-tight text-foreground-950 md:text-5xl">
              为慢热感情线，做一场心动马拉松
            </h1>
            <p className="mt-5 max-w-2xl text-[15px] leading-relaxed text-foreground-600 md:text-base">
              桃桃漫画网聚集了一批擅长刻画桃色剧情、暧昧桥段与恋爱拉扯的优质作品。
              我们相信，最动人的心动往往藏在慢慢升温的瞬间里——一个眼神、一句试探、一次脸红。
              这里就是为喜欢这种细腻感情的读者，精心准备的内容之家。
            </p>
          </div>
        </section>

        {/* 内容原则 */}
        <section className="mx-auto w-full max-w-[1400px] px-4 py-14 md:py-20">
          <div className="text-center">
            <h2 className="font-display text-3xl text-foreground-950 md:text-4xl">我们的内容原则</h2>
            <p className="mx-auto mt-3 max-w-xl text-[15px] text-foreground-600">
              从选品到推荐，我们坚持四件事，让每一部作品都值得你为它脸红。
            </p>
          </div>
          <div className="mt-8 grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-4">
            {principles.map((p) => (
              <div
                key={p.title}
                className="rounded-2xl border border-background-200/70 bg-background-50 p-5 transition-colors hover:border-primary-200"
              >
                <span className="flex h-11 w-11 items-center justify-center rounded-xl bg-primary-100 text-primary-600">
                  <i className={`${p.icon} text-xl`}></i>
                </span>
                <h3 className="mt-4 text-[15px] font-bold text-foreground-950">{p.title}</h3>
                <p className="mt-2 text-sm leading-relaxed text-foreground-600">{p.desc}</p>
              </div>
            ))}
          </div>
        </section>

        {/* 定位与理念 */}
        <section className="bg-background-100/70 py-14 md:py-20">
          <div className="mx-auto grid w-full max-w-[1400px] grid-cols-1 gap-10 px-4 lg:grid-cols-2">
            <div>
              <span className="inline-flex items-center gap-2 text-sm font-medium text-accent-600">
                <i className="ri-compass-3-line"></i>
                网站定位
              </span>
              <h2 className="mt-3 font-display text-3xl text-foreground-950">只做恋爱剧情，只做心动瞬间</h2>
              <p className="mt-4 text-[15px] leading-relaxed text-foreground-600">
                桃桃漫画网不做大而全的漫画聚合，而是聚焦恋爱这一个方向，把桃色剧情、暧昧桥段、脸红情节与恋爱拉扯做深做透。
                六大同类型栏目让不同口味的读者都能精准找到对味的作品，编辑精选则帮你把每一部值得嗑的宝藏都捞上来。
              </p>
            </div>
            <div>
              <span className="inline-flex items-center gap-2 text-sm font-medium text-accent-600">
                <i className="ri-road-map-line"></i>
                发展理念
              </span>
              <h2 className="mt-3 font-display text-3xl text-foreground-950">慢下来，才看得到心动</h2>
              <p className="mt-4 text-[15px] leading-relaxed text-foreground-600">
                我们相信好的恋爱剧情值得被认真对待。与其用爆点轰炸，不如陪你把感情线慢慢读完。
                从选品到剧情解读，桃桃编辑部始终站在读者的角度，用心挖掘那些情感发展细腻、心动瞬间密集的好作品，
                让每一次阅读都成为一次真实的心跳体验。
              </p>
            </div>
          </div>
        </section>

        {/* 用户口碑 */}
        <section className="mx-auto w-full max-w-[1400px] px-4 py-14 md:py-20">
          <div className="text-center">
            <span className="inline-flex items-center gap-2 text-sm font-medium text-secondary-600">
              <i className="ri-chat-3-fill"></i>
              读者口碑
            </span>
            <h2 className="mt-2 font-display text-3xl text-foreground-950 md:text-4xl">他们说</h2>
          </div>
          <div className="mt-8 grid grid-cols-1 gap-4 md:grid-cols-3">
            {testimonials.map((t) => (
              <figure
                key={t.name}
                className="flex flex-col rounded-2xl border border-background-200/70 bg-background-50 p-5"
              >
                <div className="flex gap-1 text-accent-500">
                  {[1, 2, 3, 4, 5].map((n) => (
                    <i key={n} className="ri-star-fill text-sm"></i>
                  ))}
                </div>
                <blockquote className="mt-3 flex-1 text-[15px] leading-relaxed text-foreground-700">
                  「{t.text}」
                </blockquote>
                <figcaption className="mt-4 flex items-center gap-3">
                  <img src={t.avatar} alt={`${t.name} 的头像`} className="h-10 w-10 rounded-full object-cover" />
                  <div>
                    <p className="text-sm font-bold text-foreground-950">{t.name}</p>
                    <p className="text-xs text-foreground-500">{t.role}</p>
                  </div>
                </figcaption>
              </figure>
            ))}
          </div>
        </section>

        {/* 联系方式 */}
        <section className="bg-background-100/70 py-14 md:py-20">
          <div className="mx-auto flex w-full max-w-[1400px] flex-col items-center px-4 text-center">
            <h2 className="font-display text-3xl text-foreground-950 md:text-4xl">想聊点什么？</h2>
            <p className="mx-auto mt-3 max-w-xl text-[15px] text-foreground-600">
              作品推荐、更新反馈、合作洽谈或任何建议，都欢迎随时联系我们。桃桃编辑部一直在。
            </p>
            <div className="mt-6 grid w-full max-w-3xl grid-cols-1 gap-4 sm:grid-cols-3">
              <div className="rounded-2xl bg-background-50 p-5">
                <i className="ri-mail-line text-2xl text-primary-500"></i>
                <p className="mt-2 text-sm font-bold text-foreground-950">邮箱</p>
                <p className="mt-1 text-sm text-foreground-600">hello@taotao-manga.example.com</p>
              </div>
              <div className="rounded-2xl bg-background-50 p-5">
                <i className="ri-wechat-line text-2xl text-primary-500"></i>
                <p className="mt-2 text-sm font-bold text-foreground-950">公众号</p>
                <p className="mt-1 text-sm text-foreground-600">桃桃漫画网官方</p>
              </div>
              <div className="rounded-2xl bg-background-50 p-5">
                <i className="ri-time-line text-2xl text-primary-500"></i>
                <p className="mt-2 text-sm font-bold text-foreground-950">服务时间</p>
                <p className="mt-1 text-sm text-foreground-600">周一至周日 09:00-22:00</p>
              </div>
            </div>
            <Link
              to="/"
              className="mt-8 flex items-center gap-2 whitespace-nowrap rounded-full bg-primary-500 px-7 py-3 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600"
            >
              回首页逛逛
              <i className="ri-arrow-right-line"></i>
            </Link>
          </div>
        </section>
      </main>
      <Footer />
      <BackToTop />
    </>
  );
}